module.exports = __webpack_public_path__ + "img/ic_brand_n.fe2a354.svg";